import * as remoteAction from "../remoteAction";

export type GetLedgerHeadActionSuccess = remoteAction.MerchantRemoteResponse<
  "LOYALTY_GET_LEDGER_SUCCESS",
  any
>;
export type GetLedgerHeadActionFailure = remoteAction.MerchantRemoteResponse<
  "LOYALTY_GET_LEDGER_FAILURE",
  any
>;
export type GetLedgerHeadActionRequest = remoteAction.MerchantRemoteResponse<
  "LOYALTY_GET_LEDGER_REQUEST",
  any
>;

export interface GetLedgerHeadAction extends remoteAction.GetRemoteRequest {
  types: {
    request: "LOYALTY_GET_LEDGER_REQUEST";
    success: "LOYALTY_GET_LEDGER_SUCCESS";
    failure: "LOYALTY_GET_LEDGER_FAILURE";
  };
}

export interface GetLedgerHeadParams {
  currency: string;
}

export const getLedgerHead = ({
  currency,
}: GetLedgerHeadParams): GetLedgerHeadAction => ({
  type: "MERCHANT_REMOTE_REQUEST",
  types: {
    request: "LOYALTY_GET_LEDGER_REQUEST",
    failure: "LOYALTY_GET_LEDGER_FAILURE",
    success: "LOYALTY_GET_LEDGER_SUCCESS",
  },
  method: "GET",
  https: true,
  params: {
    currency,
  },
  url: `/rewards/ledgers`,
});
